import React from "react";
import styled from "styled-components";

function AuthWrapper({ bg, children }) {
  return (
    <Container style={{ backgroundImage: `url(${bg})` }}>{children}</Container>
  );
}

export default AuthWrapper;
const Container = styled.section`
  background-size: cover !important;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
  p {
    font-size: 12px;
    text-align: center;
    a {
      color: #038aca;
      text-decoration: none;
    }
  }
  main {
    width: 800px;
    background-color: #fff;
    box-shadow: 0px 21px 44px rgba(36, 70, 87, 0.13);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 20px;
    height: fit-content;
    @media (max-width: 767px) {
      width: fit-content;
      padding: 30px;
    }
    & > img {
      width: 100%;
      flex: 0 0 45%;
      overflow: hidden;
      @media (max-width: 767px) {
        display: none;
      }
    }
    small {
      color: red;
      font-weight: 400;
      display: block;
      margin-top: -15px;
      margin-bottom: 10px;
    }
    div {
      border: 0.2px solid #acacac36;
      width: 100%;
      flex: 0 0 35%;
      margin-left: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      min-height: 320px;
      padding-top: 80px;
      padding-bottom: 20px;
      @media (max-width: 767px) {
        flex: 0 0 100%;
        margin-left: 0;
      }
      img {
        position: absolute;
        top: -72px;
        flex: 0 0 45%;
      }
      h1 {
        margin-bottom: 15px;
      }

      form {
        width: 80%;
      }
    }
  }
`;
